import {createAction} from 'redux-actions'

const action = name => createAction(`global/${name}`)

export const setError = action('SET_ERROR')
export const setNotFound = action('SET_NOT_FOUND')
export const navigate = createAction('NAVIGATE')
export const setMyCompanyIds = action('SET_MY_COMPANY_IDS')
export const setMyIndustryIds = action('SET_MY_INDUSTRY_IDS')
